export const DATABASE_NAME = 'ascend-invictus';
export const DATABASE_SCHEMA_VERSION = 1;
export const PERSISTENCE_RECORD_VERSION = 1;
